import { render } from "./BookingSuccessPage.vue?vue&type=template&id=20f65872"
import script from "./BookingSuccessPage.vue?vue&type=script&lang=js"
export * from "./BookingSuccessPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__